<template>
  <div class="container-fluid">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../../directives/VueFileUploader.js";

export default {
  name: "VenueTrainingImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['venueTrainingInstance'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    var files = [];

    if (this.venueTrainingInstance.imageUrls !== null) {
      files = this.venueTrainingInstance.imageUrls.map(imageUrl => (
      {
          name: 'venue-training.jpg',
          size: 1,
          type: 'image/jpg',
          file: imageUrl,
          data: {
            url: imageUrl
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API +'/VenueTrainingImages/' + this.venueTrainingInstance.id;

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>